"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectionType = void 0;
var RedirectionType;
(function (RedirectionType) {
    RedirectionType["Workshop"] = "workshop";
    RedirectionType["Course"] = "course";
    RedirectionType["PopupStore"] = "popupStore";
})(RedirectionType || (exports.RedirectionType = RedirectionType = {}));
